import I18nForLwText from './LwText'

export default class I18nForLwUploadFile extends I18nForLwText {
  name = 'lw-upload-file'
}
